import { HttpClient } from './http-client';
import User from '../interfaces/user';
import { Observable } from 'rxjs';

export class InternalAuthService extends HttpClient {
  csrf() {
    return this.get(`/sanctum/csrf-cookie`);
  }

  login(username: string, password: string) {
    return this.post(`/api/internal/auth/login`, { username, password });
  }

  user(): Observable<User> {
    return this.get<User>(`/api/internal/auth/user`);
  }

  logout() {
    return this.post(`/api/internal/auth/logout`);
  }
}
